var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-layout',{staticClass:"log-table"},[_c('mh-json-table',{ref:"logTable",staticClass:"table",attrs:{"formId":"5f2bae52adbe1d0001a39e1d","bordered":"","actions":['filter'],"filter":_vm.filter}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }